import ProfileContainer from "../components/ProfileContainer";
import { useTalent } from "../../../providers/TalentProvider";


const FOCUS_LEVELS = {
    1: '1 - I do not use AI tools',
    2: '2 - Unlikely to use AI tools',
    3: '3 - Curious about using AI tools',
    4: '4 - Somewhat focused on using AI tools',
    5: '5 - Very focused on using AI tools',
}

const TalentProfileAiExperience = () => {
    const { talent } = useTalent();
    const { ai_focus_level, ai_work_approach } = talent;

    return (
        <div id="ai-experience" className="pt-2 pb-8">
            <ProfileContainer>
                <div className="flex flex-col gap-6">
                    <h4 className="textbold text-lg">
                        AI Experience
                    </h4>

                    {ai_focus_level <= 1 ? (
                        <p className="italic pt-4">{talent.firstNamePlusInitial()} does not use AI</p>
                    ) : (
                        <>
                            <div>
                                <p className="font-semibold pb2">AI Focus Level</p>
                                <p className="italic text-xs pb-2.5 text-wrippleBlueGray">On a scale of 1-5, how focused are you on integrating AI tools into the deliverables you create for clients?</p>
                                <p>{FOCUS_LEVELS[ai_focus_level]}</p>
                            </div>
                            <div>
                                <p className="font-semibold">Overall approach to using AI</p>
                                <p className="italic text-xs pb-2.5 text-wrippleBlueGray">What is your overall approach to using AI in your work?</p>
                                <p>{ai_work_approach}</p>
                            </div>
                        </>
                    )}
                </div>
            </ProfileContainer>

        </div>
    )
}

export default TalentProfileAiExperience;
